import http from '../../../common/utils/http'
import apiUtils from '../../../common/utils/apiUtils'
import { API_BASE_URL } from '../../../common/utils/commonUrl'

export default {
  getCancelRecord: (data) => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getEmployeeVerifySalesDTOList`, { params: data }).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  commitApplication: (data) => {
    return http.post(`${API_BASE_URL}/api/wxoa/member/member/addMemberReservationInfo`, data).then(
      function (result) {
        return apiUtils.getDataFormCodeResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getMemberAppointmentInfo: () => {
    return http.get(`${API_BASE_URL}/api/wxoa/member/member/getMemberReservationInfoList`).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/cancel-coupon/cancel-coupon.js